<lib-modal-container class="bootstrap-wrapper" classModalTitle="bg-azul-sunedu" [modalTitle]="'Actualización de cuota'"
  cancelText="Cerrar" [noActions]="true" (dismiss)="handleClose()">

  <div fxLayout="column" class="m-b-25">
    <div *ngIf="tokenSended" class="text-center">
      <label class="font-bold">Se actualizó la cuota.</label>
    </div>
    <div *ngIf="showError" class="text-center">
      <label class="font-bold">Ocurrió un problema, vuelva a intentarlo.</label>
    </div>
    <div *ngIf="!tokenSended && showError == null" fxFlex="auto" class="text-left">
      <form fxFlex="auto" [formGroup]="form">
        <div class="font-bold">Cantidad de cuota asignada</div>
        <lib-form-control appearance="outline" variant="text" [formGroupParent]="form" label="Cantidad de cuota asignada"
          controlName="cuotaAsignada" [inputProps]="{maxlength:4} ">
        </lib-form-control>
        <div class="font-bold">Cantidad de cuota realizada</div>
        <lib-form-control appearance="outline" variant="text" [formGroupParent]="form" label="Cantidad de cuota realizada"
          controlName="cuotaRealizada" [inputProps]="{maxlength:4}" [disabled]="true">
        </lib-form-control>
        <div class="font-bold">Cantidad de cuota restante</div>
        <lib-form-control appearance="outline" variant="text" [formGroupParent]="form" label="Cantidad de cuota restante"
          controlName="cuotaRestante" [inputProps]="{maxlength:4}" [disabled]="true">
        </lib-form-control>
        <button class="p-l-0" mat-button (click)="handleClickSinLimite()">
          <mat-icon *ngIf="!checkSinLimite">check_box_outline_blank</mat-icon>
          <mat-icon *ngIf="checkSinLimite" class="text-naranja-sunedu">
            check_box
          </mat-icon>
        </button>
        Sin límites
      </form>
    </div>
    <div *ngIf="!tokenSended && showError == null" class="text-center">
      <button (click)="handleEnviar()" [disabled]="loading" mat-flat-button [ngClass]="!loading ? 'bg-azul-sunedu rounded-full m-l-15':'bg-gray-sunedu rounded-full m-l-15'">
        Actualizar
      </button>
    </div>
  </div>

</lib-modal-container>